/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Teachingsubjectinterest_Subject_Biology16Inputs */

const en__field__enum_teachingsubjectinterest_subject_biology16 = /** @type {(inputs: _Field__Enum_Teachingsubjectinterest_Subject_Biology16Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biology`)
};

const de__field__enum_teachingsubjectinterest_subject_biology16 = /** @type {(inputs: _Field__Enum_Teachingsubjectinterest_Subject_Biology16Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biologie`)
};

/**
* | output |
* | --- |
* | "Biology" |
*
* @param {_Field__Enum_Teachingsubjectinterest_Subject_Biology16Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_teachingsubjectinterest_subject_biology16 = /** @type {((inputs?: _Field__Enum_Teachingsubjectinterest_Subject_Biology16Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Teachingsubjectinterest_Subject_Biology16Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_teachingsubjectinterest_subject_biology16(inputs)
	return de__field__enum_teachingsubjectinterest_subject_biology16(inputs)
});
export { _field__enum_teachingsubjectinterest_subject_biology16 as "_field__enum_teachingSubjectInterest_SUBJECT_BIOLOGY" }